import { render, staticRenderFns } from "./custom-company-banner.vue?vue&type=template&id=7336f580&scoped=true&"
import script from "./custom-company-banner.vue?vue&type=script&lang=js&"
export * from "./custom-company-banner.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-banner.vue?vue&type=style&index=0&id=7336f580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336f580",
  null
  
)

export default component.exports